import { render, staticRenderFns } from "./FortisCardPayment.vue?vue&type=template&id=00ca9844"
import script from "./FortisCardPayment.vue?vue&type=script&lang=js"
export * from "./FortisCardPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports